import { Text, Stack, Link } from '@hotjar/hotsauce';
import { Trans, useTranslation } from 'react-i18next';
import { useHelpHotjarUrl } from '@hotjar/translations';

interface Props {
  ownerEmail: string;
  additionalEmails?: string[];
}

const SUPPORT_LINK = '/requests/new?ticket_form_id=360000390393';

export function InvoiceListPlaceholder({ ownerEmail, additionalEmails }: Props): JSX.Element {
  const { t } = useTranslation();
  const helpHotjarUrl = useHelpHotjarUrl();

  const additionalEmailsList = additionalEmails?.join(', ');

  return (
    <Stack direction="column" spacing="x3">
      <Text as="h2" textType="header5">
        {t('checkout:invoices.title')}
      </Text>
      <Stack direction="column" spacing="x1">
        <Text>
          {t('checkout:invoices.placeholder.where-to-find-invoices', {
            context: additionalEmails && additionalEmails?.length > 0 ? 'additionalEmails' : null,
            ownerEmail,
            additionalEmailsList,
          })}
        </Text>
        <Text>
          <Trans
            i18nKey="checkout:invoices.placeholder.contact-support"
            components={[
              <Link kind="inline" href={`${helpHotjarUrl}${SUPPORT_LINK}`} isExternal>
                contact support
              </Link>,
            ]}
          />
        </Text>
      </Stack>
    </Stack>
  );
}
